// extracted by mini-css-extract-plugin
module.exports = {"discoverBtnWhite":"DiscoverButton_discoverBtnWhite__3ubg0","discoverBtnGradient":"DiscoverButton_discoverBtnGradient__3JvoT"};